import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  Card,
  CardContent,
  Typography,
  Button,
  Snackbar,
  SnackbarContent,
  IconButton,
} from '@material-ui/core';
import { MdClose } from 'react-icons/lib/md';
import _ from 'lodash';

import { getGDGroupDetail, markGDCompleted } from '../../services/groupDiscussionDetailServices';
import blockProps from '../../utils/blockProps';
import AppShell from '../../components/AppShell';
import Loader from '../../components/Loader';
import CandidateGDCard from './components/CandidateGDCard';

class GroupDiscussionDetail extends React.Component {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.object.isRequired,
    }).isRequired,
  };

  state = {
    dataLoaded: false,
    gdDetail: null,
    loading: false,
    serverError: false,
    snackbarOpened: false,
    snackbarMessage: '',
    formErrorMessages: {},
  };

  componentDidMount() {
    this.fetchGDDetails();
  }

  fetchGDDetails = () => {
    const { groupId } = this.props.match.params;
    getGDGroupDetail(groupId, (gdDetail) => {
      this.setState({
        dataLoaded: true,
        gdDetail,
      });
    });
  };

  handleSnackbarClose = () => {
    this.setState({
      snackbarOpened: false,
      snackbarMessage: '',
      serverError: false,
    });
  };

  clearFormErrorForField = (field) => {
    this.setState(state => ({
      formErrorMessages: _.omit(state.formErrorMessages, [field]),
    }));
  };

  onSuccess = (response, callback = () => {}) => {
    this.setState(
      {
        loading: false,
        snackbarOpened: true,
        snackbarMessage: response.message,
      },
      callback,
    );
  };

  onError = (error) => {
    const errorMessages = _.get(error, 'response.data.data.errors');
    this.setState({
      loading: false,
      serverError: true,
      snackbarOpened: true,
      snackbarMessage: 'something went wrong. please try again',
      formErrorMessages: errorMessages || {},
    });
  };

  handleGDComplete = () => {
    const { groupId } = this.props.match.params;
    this.setState({ loading: true });

    markGDCompleted(
      groupId,
      (response) => {
        this.onSuccess(response, this.fetchGDDetails);
      },
      this.onError,
    );
  };

  render() {
    if (!this.state.dataLoaded) {
      return <Loader />;
    }

    if (!this.state.gdDetail) {
      return (
        <Typography variant="subheading" color="error">
          No Group Found
        </Typography>
      );
    }

    return (
      <div>
        <AppShell>
          <GroupDetailCard>
            <CardContent>
              <ButtonContainer>
                {this.state.gdDetail.completed ? (
                  <CompleteLabel variant="title" color="primary">
                    Completed
                  </CompleteLabel>
                ) : (
                  <Button variant="raised" color="primary" onClick={this.handleGDComplete}>
                    Mark Completed
                  </Button>
                )}
              </ButtonContainer>

              <Row>
                <div>
                  <Label variant="title" gutterBottom>
                    Number of Candidates
                  </Label>
                  <Label variant="subheading">{this.state.gdDetail.candidates.length}</Label>
                </div>

                <div>
                  <Label variant="title" gutterBottom>
                    City
                  </Label>
                  <Label variant="subheading">{this.state.gdDetail.jypCity}</Label>
                </div>

                <div>
                  <Label variant="title" gutterBottom>
                    Panel
                  </Label>
                  <Label variant="subheading">{this.state.gdDetail.panel}</Label>
                </div>

                <div>
                  <Label variant="title" gutterBottom>
                    GD By
                  </Label>
                  <Label variant="subheading">{this.state.gdDetail.panelist.name}</Label>
                </div>
              </Row>
            </CardContent>
          </GroupDetailCard>

          <CandidatesGDCardContainer>
            {this.state.gdDetail.candidates.map(candidateId => (
              <CandidateGDCard
                key={candidateId}
                id={candidateId}
                onSuccess={this.onSuccess}
                onError={this.onError}
                setLoading={() => {
                  this.setState({ loading: true });
                }}
                formErrorMessages={this.state.formErrorMessages}
                clearFormErrorForField={this.clearFormErrorForField}
              />
            ))}
          </CandidatesGDCardContainer>
        </AppShell>

        <Snackbar
          open={this.state.snackbarOpened}
          autoHideDuration={2000}
          onClose={this.handleSnackbarClose}
        >
          <StyledSnackbarContent
            error={this.state.serverError}
            message={this.state.snackbarMessage}
            action={[
              <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                onClick={this.handleSnackbarClose}
              >
                <MdClose size={20} />
              </IconButton>,
            ]}
          />
        </Snackbar>

        {this.state.loading && <Loader />}
      </div>
    );
  }
}

export default GroupDiscussionDetail;

const GroupDetailCard = styled(Card)`
  && {
    background-color: #651fff;
    margin-bottom: 30px;
  }
`;

const ButtonContainer = styled.div`
  text-align: right;
  margin-bottom: 30px;
`;

const CompleteLabel = styled(Typography)`
  padding: 8px;
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 10px;
  align-items: center;
  justify-items: center;
`;

const Label = styled(Typography)`
  && {
    color: #fff;
  }
`;

const CandidatesGDCardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 20px;
`;

const StyledSnackbarContent = styled(blockProps(SnackbarContent, ['error']))`
  background-color: ${props => (props.error ? 'red' : 'green')} !important;
`;



// WEBPACK FOOTER //
// ./src/pages/GroupDiscussionDetail/GroupDiscussionDetail.js